import { useState, useCallback } from "react";
import memeService from "../../../services/MemeService";
import errorHandler from "../../../services/ErrorHandler/ErrorHandler";
import notificationService from "../../../services/NotificationService";
import TestMemeButtonDisplay from "./TestMemeButtonDisplay";
import TestMemeSelectorDisplay from "./TestMemeSelectorDisplay";
import { useTranslation } from "react-i18next";
import "./index.css";
import useAsync from "../../../services/useAsync";

const TestMemeContainer = ({ extended }) => {
    const { t } = useTranslation("testMemeContainer");

    const [testMemeMessage, setTestMemeMessage] = useState(
        t("setMessageCreateAtestMeme"),
    );
    const [selectedTemplatesMap, setSelectedTemplatesMap] = useState({});
    const [isLoading, setIsLoading] = useState(true);
    const [metaData, setMetaData] = useState(null);
    const [userInputTopText, setUserInputTopText] = useState("");
    const [userInputBottomText, setUserInputBottomText] = useState("");

    //creates a test meme button only
    const createTestMemeOnClick = async () => {
        setTestMemeMessage(t("setMessageToTesting"));
        setIsLoading(true);

        try {
            const topText =
                userInputTopText.length > 0 ? userInputTopText : null;
            const bottomText =
                userInputBottomText.length > 0 ? userInputBottomText : null;
            const templateId = metaData
                ? metaData.url.split("/")[4].replace(".jpg", "")
                : null;

            if (extended) {
                if (!topText && !bottomText) {
                    setIsLoading(false);
                    notificationService.setMessage(t("noTextDetected"));
                    return;
                }
            }

            let testMemeResopnse = extended
                ? await memeService.createTestMeme(
                      topText,
                      bottomText,
                      templateId,
                  )
                : await memeService.createTestMeme();

            if (testMemeResopnse.errorCode) {
                setTestMemeMessage(
                    errorHandler.handleErrorCode(testMemeResopnse),
                );
            }

            if (testMemeResopnse.status === "null") {
                setTestMemeMessage(t("setMessageToDisplayTestMeme"));
            }

            if (testMemeResopnse.status !== "null") {
                if (testMemeResopnse.status === "Browser source not active!") {
                    notificationService.setMessage(
                        t("setMEssageToDisplaySourceNotActive"),
                    );
                } else notificationService.setMessage(testMemeResopnse.status);
            }

            setTimeout(() => {
                setTestMemeMessage(t("setMessageCreateATestMeme"));
                setIsLoading(false);
                setMetaData(null);
                setUserInputTopText("");
                setUserInputBottomText("");
            }, 4000);
        } catch (error) {
            console.log(error, metaData);
            notificationService.setMessage(
                t("setMessageFailedToCreateTestMeme"),
            );
        }
    };

    const getSelectedTemplates = useCallback(async () => {
        setSelectedTemplatesMap({});
        setTestMemeMessage(t("setMessageGettingMemes"));

        let templateAccumulationMap = {};
        let paginationToken = null;
        try {
            setIsLoading(true);

            do {
                let responseObject =
                    await memeService.listSelectedTemplates(paginationToken);

                responseObject.templates.forEach((template) => {
                    return (templateAccumulationMap[template.thumbnailUrl] =
                        template);
                });

                setSelectedTemplatesMap(templateAccumulationMap);
                paginationToken = responseObject.paginationToken;
            } while (paginationToken);

            setIsLoading(false);
        } catch (error) {
            notificationService.setMessage(t("setMessageCouldNotLoadMemes"));
            setSelectedTemplatesMap({});
        }
    }, [t]);

    useAsync(getSelectedTemplates);

    let displayComponent = !extended ? (
        <TestMemeButtonDisplay
            createTestMemeOnClick={createTestMemeOnClick}
            testMemeMessage={testMemeMessage}
        />
    ) : (
        <TestMemeSelectorDisplay
            createTestMemeOnClick={createTestMemeOnClick}
            testMemeMessage={testMemeMessage}
            selectedTemplatesMap={selectedTemplatesMap}
            isLoading={isLoading}
            setMetaData={setMetaData}
            metaData={metaData}
            setUserInputTopText={setUserInputTopText}
            setUserInputBottomText={setUserInputBottomText}
            userInputTopText={userInputTopText}
            userInputBottomText={userInputBottomText}
        />
    );

    return displayComponent;
};

export default TestMemeContainer;
